module.exports = __webpack_public_path__ + "img/58_6.ad3650a2.png";